import React from 'react';
import { FastField } from 'formik';
import { Col, FormGroup, Label } from 'reactstrap';

export default function Remark(props) {
  const { name } = props;
  
  return (
    <Col xs="12">
      <FormGroup className="mb-0">
        <Label>Remarks</Label>
        <FastField name={name}>
          {({ field, form }) => {
            const { name, value } = field;
            const { setFieldValue } = form;

            return (
              <textarea
                id={name}
                className="form-control"
                rows="5"
                placeholder="Enter Remarks if any"
                style={{ width: '100%', resize: 'none' }}
                value={value}
                onChange={e => setFieldValue(name, e.target.value)}
              />
            );
          }}
        </FastField>
      </FormGroup>
    </Col>
  );
}



// WEBPACK FOOTER //
// ./src/screens/Flights/PassengerDetails/Remark.js